import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { ModalBody } from "reactstrap";

import {
    setPrintDateTimeDeliveryModesaleItemsLines as setprintdatetimedeliverymodesaleItemsLines,
    setPrintDateTimeDeliveryModesaleMethodPayment as setprintdatetimedeliverymodesaleMethodPayment,
    setPrintDateTimeDeliveryModesaleMethodPaymentTva as setprintdatetimedeliverymodesaleMethodPaymentTva,
    setPrintDateTimeDeliveryModesaleProviderName as setprintdatetimedeliverymodesaleProviderName,
    setPrintDateTimeDeliveryModesalePrintNotes as setprintdatetimedeliverymodesalePrintNotes,
    setPrintDateTimeDeliveryModesaleWithoutPrice as setprintdatetimedeliverymodesaleWithoutPrice,
    setCustomerTicketSalesModes,
    storeCustomerTicket,
    setDateTimeDeliveryModeSale,
    setDataCustomerTicket,
} from "@components/Common/PrinterSetting/stores";

import {
    PrinterRowData,
    PrinterCustomerTicketBlock,
} from "../../types";

import UserCard from "./Hook/UserCard";

import "@assets/swal.css";
import "@assets/theme.css";
import "../index.css";

type ClientPanelSettingType = {
    rowData: PrinterRowData;
    oneShop?: boolean;
};

export default function ClientPanelSetting({
    rowData,
}: ClientPanelSettingType) {
    const { t } = useTranslation();
    const {
        customerTicketSalesModes,
        dateTimeDeliveryModeSale,
        printDateTimeDeliveryModesaleItemsLines,
        printDateTimeDeliveryModesaleMethodPayment,
        printDateTimeDeliveryModesaleMethodPaymentTva,
        printDateTimeDeliveryModesaleProviderName,
        printDateTimeDeliveryModesalePrintNotes,
        printDateTimeDeliveryModesaleWithoutPrice,
    } = useSnapshot(storeCustomerTicket);

    useEffect(() => {
        const customerTicket = rowData["customer_ticket"];
        if (customerTicket && typeof customerTicket === "object") {
            if (Object.keys(customerTicket).length > 0) {
                if (customerTicket.customerTicketSalesModes) {
                    setCustomerTicketSalesModes(
                        customerTicket.customerTicketSalesModes
                    );
                }
                if (customerTicket.dateTimeDeliveryModeSale) {
                    setDateTimeDeliveryModeSale(
                        customerTicket.dateTimeDeliveryModeSale
                    );
                }

                const printDelivery =
                    customerTicket.print_date_time_delivery_mode_sale;
                if (printDelivery) {
                    setprintdatetimedeliverymodesaleItemsLines(
                        printDelivery.items_lines ?? false
                    );
                    setprintdatetimedeliverymodesaleMethodPayment(
                        printDelivery.method_payment ?? false
                    );
                    setprintdatetimedeliverymodesaleMethodPaymentTva(
                        printDelivery.method_payment_TVA ?? false
                    );
                    setprintdatetimedeliverymodesaleProviderName(
                        printDelivery.provider_name ?? false
                    );
                    setprintdatetimedeliverymodesalePrintNotes(
                        printDelivery.print_notes ?? false
                    );
                    setprintdatetimedeliverymodesaleWithoutPrice(
                        printDelivery.without_price ?? false
                    );
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const data: PrinterCustomerTicketBlock = {
            customerTicketSalesModes,
            dateTimeDeliveryModeSale,
            print_date_time_delivery_mode_sale: {
                provider_name: printDateTimeDeliveryModesaleProviderName,
                without_price: printDateTimeDeliveryModesaleWithoutPrice,
                print_notes: printDateTimeDeliveryModesalePrintNotes,
                items_lines: printDateTimeDeliveryModesaleItemsLines,
                method_payment: printDateTimeDeliveryModesaleMethodPayment,
                method_payment_TVA: printDateTimeDeliveryModesaleMethodPaymentTva,
            },
        };
        setDataCustomerTicket(data);
    }, [
        printDateTimeDeliveryModesaleProviderName,
        printDateTimeDeliveryModesaleWithoutPrice,
        printDateTimeDeliveryModesalePrintNotes,
        printDateTimeDeliveryModesaleItemsLines,
        printDateTimeDeliveryModesaleMethodPayment,
        printDateTimeDeliveryModesaleMethodPaymentTva,
        customerTicketSalesModes,
        dateTimeDeliveryModeSale,
    ]);

    return (
        <React.Fragment>
            <ModalBody style={{ height: "730px" }}>
                <div className="px-3 mt-2">
                    <h4 style={{ fontSize: "24px" }}>{t("Customer ticket")}</h4>
                </div>
                <UserCard customerTicketSalesModes={customerTicketSalesModes} />
            </ModalBody>
        </React.Fragment>
    );
}
